import { config } from "../../../app-confi/app-config";
import { columnDefs } from "./models/column-definition";
import { columnType } from "./models/column-type.enum";
import { coreType } from "./models/core-type.enum";
import { coreTypesModel } from "./models/core-types.model";
import { headType } from "./models/head-type.enum";
import { headTypesModel } from "./models/head-types.model";
import { MoosPlazaType, moosPlazaTypesModel } from "./models/moos-plaza-types.model";
import { PropsTower } from "./models/props-config";

export class TowerService {

    static getColumnBays(type: columnType) {
        if (type !== columnType.none) {
            const findMoosPlazaType = columnDefs.find(s => s.type === type);
            return findMoosPlazaType.bays;
        } else {
            return 0;
        }
    }
    static validateMoosPlazaIsAmongAvailable(selectedHeadType: headType, selectedCoreType: coreType, selectedMoosPlazaType: columnType) {
        const availableMoosPlazaTypes = TowerService.getAvailableMoosPlazaTypes(selectedHeadType, selectedCoreType);
        return TowerService.checkIfMoosPlazaIsAmongAvailable(availableMoosPlazaTypes, selectedMoosPlazaType);
    }

    static getAvailableMoosPlazaTypes(selectedHeadType: headType, selectedCoreType: coreType) {
        const head = headTypesModel.find(h => h.type === selectedHeadType);
        const core = coreTypesModel.find(c => c.type === selectedCoreType);
        const availableBays = core.bays - head.coreDiffBays;
        const moosPlazaTypesAvailable = moosPlazaTypesModel.filter(moosplaza => (moosplaza.type !== columnType.none) && (moosplaza.bays === availableBays || moosplaza.bays <= availableBays - 1));
        const noneMoos = moosPlazaTypesModel.find(m => m.type === columnType.none);
        moosPlazaTypesAvailable.push(noneMoos);
        return moosPlazaTypesAvailable;
    }

    static checkIfMoosPlazaIsAmongAvailable(moosPlazaTypesAvailable: MoosPlazaType[], moosPlazaType: columnType) {
        return moosPlazaTypesAvailable.some(m => m.type === moosPlazaType);
    }

    static getTotalFloors(p: PropsTower) {
        return Math.floor(p.buildingHeight / config.towerFloorHeight);
    }

    static getMoosPlazaBays(type: columnType) {
        const findMoosPlazaType = moosPlazaTypesModel.find(s => s.type === type);
        return findMoosPlazaType.bays;
    }

    static getCoreBays(type: coreType) {
        const findCoreType = coreTypesModel.find(s => s.type === type);
        return findCoreType.bays;
    }

}